<template>
 <div class="bg-[#23242A] text-white  px-6 pt-6 h-screen pb-52 lg:h-[calc[100vh_-_100px]] overflow-y-auto">

    <div :class="'flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
      
      <div class="custom-full">
        <Nav/>
        
        <block-loading v-if="loadingBadges"/>
        <template v-else>

          <div class="bg-[#2B2C32] rounded-lg px-[16px] max-w-full py-[16px]" v-if="loyaltyProgram && loyaltyProgram.id">
            <div class="mb-3 flex justify-between">
              <h3 class="text-[24px] text-white font-semibold">Badges</h3>
              <mdicon @click="addUpdate({ component: 'Add', data: {} })" v-if="!action.component && can_edit_membership_details" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
            </div>
            <List :selectedCallback="selectedItem" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/> 
          </div>

          <div v-else class="p-3 bg-[#2B2C32] border-0 rounded-lg">
            <div class="mb-3 flex justify-between">
              <h3 class="text-[20px] text-theme-878686 font-bold tracking-wider">Badges</h3>
            </div>
            <p class="text-sm"> Loyalty Program is inactive or not set.</p>
          </div>
        </template>
      </div>
  
      <div :class="'w-full hidden-component z-10'" v-if="action.component" >
        <component :is="action.component"  :earningSetting="earningSetting" :loyaltyProgramId="loyaltyProgram.id" :item="action.data" :clearComponent="clearComponent"></component>
      </div>

  </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import List from '@/views/Membership/Program/Badges/List.vue';
import Add from '@/views/Membership/Program/Badges/Add.vue';
import Update from '@/views/Membership/Program/Badges/Update.vue';
import Nav from "@/views/Membership/Program/Nav.vue";
import LoyaltyProgramApis from "@/controllers/LoyaltyProgramApis";
import LoyaltyEarnSettingApis from "@/controllers/LoyaltyEarnSettingApis";
import Helpers from '@/helpers';

  export default defineComponent({
  name: "MembershipBadges",
  components: {
    Nav,
    List,
    Add,
    Update,
  },

  setup() {
    const action = ref<object>({
      component: '',
      data: {},
    });
    const loyaltyProgram = <any>ref({
      id: null
    });
    const earningSetting = ref({});
    const loadingBadges = ref(false);
    return {
      action,
      earningSetting,
      loyaltyProgram,
      loadingBadges
    };
  },

  watch : {
    'vg_selectedLocation'(val) {
      // if location selected clear component
      this.clearComponent();
    },
  },

  computed: {

    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },

    ...mapGetters({
     vg_selectedLocation: 'location/selected'
    }),
  },

  async mounted() {
    this.loadingBadges = true;
    let loyaltyProgramRes = await LoyaltyProgramApis.getProgramByCurrentActiveBusiness();
    if(loyaltyProgramRes.status == 200 || loyaltyProgramRes.status == 201) {
     this.loyaltyProgram = loyaltyProgramRes.data;
     let res = await LoyaltyEarnSettingApis.fetchSetting(loyaltyProgramRes.data.id);
     if(res.status == 200) {
      this.earningSetting = res.data;
     }
    }
    this.loadingBadges = false;
    this.emitter.on("reset-badges-component", data => {
      this.clearComponent();
    });
  },

  beforeDestroy() {
    this.emitter.off('reset-badges-component', () => {});
  },
 
  methods: {
    /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })
  },
});

</script>


